import { Example } from '@/types';
import { useOrgStore } from '@/stores/org-store';
import { apiRequest } from '@/utils/api-request';

interface CreateGuardrailsConfigProps {
  name: string;
  description: string;
  passCriteria: string;
  failCriteria: string;
  examples: Example[];
  active: boolean;
  override: boolean;
}

export const createGuardrailsConfig = async ({
  name,
  examples,
  description,
  passCriteria,
  failCriteria,
  active,
  override,
}: CreateGuardrailsConfigProps) => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;

  const response = await apiRequest({
    url: `/guardrails/${orgId}`,
    method: 'POST',
    target: 'platform',
    body: {
      name,
      examples,
      guardrail_description: description,
      pass_criteria: passCriteria,
      fail_criteria: failCriteria,
      active,
      override,
    },
  });

  if (response?.detail) {
    return { detail: response.detail || 'Failed to create guardrails config' };
  }

  return response;
};
